import { render, staticRenderFns } from "./AccordionObjectivesList.vue?vue&type=template&id=65f9a80d&scoped=true"
import script from "./AccordionObjectivesList.vue?vue&type=script&lang=js"
export * from "./AccordionObjectivesList.vue?vue&type=script&lang=js"
import style0 from "./AccordionObjectivesList.vue?vue&type=style&index=0&id=65f9a80d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f9a80d",
  null
  
)

export default component.exports